import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './vtsolution.component.html',
    styleUrls: ['./vtsolution.component.scss']
})

export class VTSolutionComponent implements OnInit {
    model = {
        left: true,
        middle: false,
        right: false
    };

    focus;
    focus1;
    constructor() { }

    ngOnInit() {}
}
